import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Form, withFormik } from 'formik';
import { TextField, FlatButton, RaisedButton } from 'material-ui';
import * as Yup from 'yup';

const DesignateAnotherUserSchema = Yup.object().shape({
  message: Yup.string(),
});

class DeclineForm extends Component {
  setValue = (field, value) => {
    const { setFieldValue, setFieldTouched } = this.props;
    setFieldValue(field, value);
    setFieldTouched(field, true, false);
  }

  render = () => {
    const {
      values, errors, touched, onDecline, onCancel, isValid,
    } = this.props;

    return (
      <StyledForm>
        <Header>
          Please explain the reason for declining below.
        </Header>
        <TextField
          value={values.message}
          onChange={e => this.setValue('message', e.target.value)}
          errorText={touched.message && errors.message}
          floatingLabelText="Message"
          hintText="Your Message"
          type="text"
          fullWidth
        />
        <ActionsContainer>
          <FlatButton primary onClick={onCancel}>
            CANCEL
          </FlatButton>
          <RaisedButton
            primary
            buttonStyle={{ color: 'white' }}
            onClick={() => {
              onDecline(values.message);
              onCancel();
            }}
            disabled={!isValid}
          >
            DECLINE
          </RaisedButton>
        </ActionsContainer>
      </StyledForm>
    );
  }
}

DeclineForm.propTypes = {
  values: PropTypes.any.isRequired,
  errors: PropTypes.any.isRequired,
  touched: PropTypes.any.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  onDecline: PropTypes.func,
  onCancel: PropTypes.func,
};

DeclineForm.defaultProps = {
  onDecline: () => {},
  onCancel: () => {},
};

const StyledForm = styled(Form)`
  width: 100%;

  & button > div {
    font-weight: 600 !important;
    font-size: 0.9rem !important;
  }
`;

const ActionsContainer = styled.div`
  width: 98%;
  margin-top: 2rem;
  text-align: right;
  & > div {
    margin-left: 1rem;
  }
`;

const Header = styled.div`
  width: 90%;
  color: black;
  POSI
`;

export default withFormik({
  validationSchema: DesignateAnotherUserSchema,
  enableReinitialize: true,
  handleSubmit: (values, { props }) => {
    if (props.onSubmit) props.onSubmit(values);
  },
})(DeclineForm);
